import { companylogo } from "../assets";

const CompanyLogos = ({ className }) => {
  return (
    <div className={className}>
      <p className="tagline mb-6 hidden text-center text-n-1/50 lg:block xl:text-base">
        Helping people create beautiful products using
      </p>
      <div className="hidden lg:flex">
        <div className="hidden h-[8.5rem] flex-1 items-center justify-center lg:flex">
          <img
            src={companylogo}
            width={941}
            height={60}
            alt="Technology Logos"
            className="hidden lg:block"
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyLogos;
